import { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@evertrue/et-components';
import classNames from 'classnames';

/**
 * Collapsible section for displaying data with expand/collapse functionality.
 * Used within the drill-down modal to group High Quality, Low Confidence, and Rejected matches.
 */
const CollapsibleSection = ({ title, count = 0, defaultExpanded = false, children }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="collapsible-section">
      <button type="button" className="collapsible-section--header" onClick={handleToggle} aria-expanded={isExpanded}>
        <span className="collapsible-section--title">
          {title} ({count})
        </span>
        <Icon
          icon="chevron-down"
          className={classNames('collapsible-section--chevron', {
            'collapsible-section--chevron-expanded': isExpanded,
          })}
        />
      </button>
      {isExpanded && <div className="collapsible-section--content">{children}</div>}
    </div>
  );
};

CollapsibleSection.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number,
  defaultExpanded: PropTypes.bool,
  children: PropTypes.node,
};

export default CollapsibleSection;
